import { Component, OnInit } from '@angular/core';
import { WalletService } from '../services/wallet.service';


@Component({
  selector: 'ngx-wallet-connect-dialog',
  templateUrl: './wallet-connect-dialog.component.html',
  styleUrls: ['./wallet-connect-dialog.component.scss']
})
export class WalletConnectDialogComponent implements OnInit {

  constructor(public _walletService: WalletService) { }
  private currentUserAddress;
  ngOnInit(): void {
  }
  connectMetamask = async() => {
    this.currentUserAddress = await this._walletService.initConnection();
    // this._apiService.insertWhitelistedAddress(this.currentUserAddres).subscribe();
  }
  connectWalletConnect = async() => {
    await this._walletService.createConnectionWalletConnect()
    
  }
}
